import React from "react";
import "./Header.css";
import image from "../assets/logo.svg";

const Header: React.FC = () => (
  <header className="header">
    <div className="header-container">
      <div className="logo-section">
        <a href="#home" className="logo-link">
          <img src={image} alt="Arqite Logo" className="logo-image" />
        </a>
        <div className="logo-text">ARQITE</div>
      </div>
      
      <nav className="nav-menu">
        <a href="#features" className="nav-link active">
          <span>Product</span>
        </a>
        <a href="#workflow" className="nav-link">
          <span>Workflow</span>
        </a>
        <a href="#reporting" className="nav-link">
          <span>Reporting</span>
        </a>
        <a href="#contact" className="nav-link">
          <span>Contact</span>
        </a>
      </nav>
      
      <div className="header-actions">
        <a href="https://app.arqite.com" className="cta-button" target="_blank" rel="noopener noreferrer">
          <span>Login</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </a>
      </div>
    </div>
  </header>
);

export default Header;
